import { useRef, useEffect } from "react";
import { Card, Button, Space } from "antd";
import HealthTable from "../charts/Health_Table";
// import AlarmRatioChart from "./charts/Alarm_Ratio";
import HealthBar from "../charts/Health_Bar";
import SignalBar from "Components/Report/OnDemand/charts/Singal_Bar";
// import UptimeLine from "Components/Report/OnDemand/charts/Uptime_Line";
import { useReactToPrint } from "react-to-print";
import UsageBarLine from "Components/Report/OnDemand/charts/Usage_Bar_Line";
// import UsageWANLine from "Components/Report/OnDemand/charts/Usage_WAN_Line";
import SignalTable from "Components/Report/OnDemand/charts/Signal_Table";
// import UptimeTable from "Components/Report/OnDemand/charts/Uptime_Table";
import CellularUsageTable from "Components/Report/OnDemand/charts/Usage_Cellular_Table";
import WANUsageTable from "Components/Report/OnDemand/charts/Usage_WAN_Table";
import { useAppSelector } from "store/hook";
import { AccountValues, DeviceValues } from "../Filter";
import styles from "Components/Report/report.module.scss";
import DeviceCharts from "./DeviceCharts";
import AccountCharts from "./AccountCharts";
import DeviceChartsDrawer from "../Device_Charts_Drawer";
import PreferenceDrawer from "./preference/Preference";
import CoverPage, { EndPage } from "Components/Report/OnDemand/chartsList/PrintCover";
import { ReportDeviceStatus, ReportAccountStatus } from "Utility/Types/report";
import MultiDrawer from "../MultiDrawer";
import ExportCSV from "./exportCSV";
import { useAppDispatch } from "store/hook";
import { setFilterForm } from "Components/Report/reportSlice";

interface GetComponentListProps {
  param: AccountValues | DeviceValues;
  data?: ReportDeviceStatus[] | ReportAccountStatus[];
  id?: string;
  isFetching: boolean;
  name?: string;
}

export const getComponentList = ({
  param,
  data,
  id,
  isFetching,
  name,
}: GetComponentListProps): { component: React.ReactElement; value: (AccountValues | DeviceValues)[] }[] => [
  {
    component: <HealthTable isFetching={isFetching} param={param} id={id} />,
    value: ["account_health_table"],
  },
  {
    component: <SignalTable isFetching={isFetching} param={param} id={id} />,
    value: ["account_signal_table"],
  },
  {
    component: <WANUsageTable isFetching={isFetching} param={param} id={id} />,
    value: ["account_usage_ewan_table"],
  },
  {
    component: <CellularUsageTable isFetching={isFetching} param={param} id={id} />,
    value: ["account_usage_cellular_table"],
  },
  {
    component: <HealthBar isFetching={isFetching} param={param} id={id} data={data} name={name} />,
    value: ["account_health", "device_health"],
  },
  {
    component: <SignalBar isFetching={isFetching} param={param} id={id} data={data} name={name} />,
    value: ["account_signal", "device_signal"],
  },
  // { component: <UptimeLine isFetching={isFetching} param={param} id={id} data={data} />, value: ["device_uptime"] },
  // { component: <UptimeLine isFetching={isFetching} param={param} id={id} data={data} />, value: ["device_uptime_wan"] },
  // {
  //   component: <UptimeLine isFetching={isFetching} param={param} id={id} data={data} />,
  //   value: ["device_uptime_celluar"],
  // },
  {
    component: <UsageBarLine isFetching={isFetching} param={param} id={id} data={data} name={name} />,
    value: ["device_wan_usage"],
  },
  {
    component: <UsageBarLine isFetching={isFetching} param={param} id={id} data={data} name={name} />,
    value: ["device_celluar_usage"],
  },
];

const ChartsList = () => {
  const componentRef = useRef(null);
  const dispatch = useAppDispatch();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Osmart RAM-Report-${Date.now()}`,
  });

  const { filterForm, isFetchingAPI } = useAppSelector((status) => status.report);
  const { isDarkMode, stateCid } = useAppSelector((status) => status.global);

  const account_parameter = filterForm.account_parameter || [];

  useEffect(() => {
    dispatch(
      setFilterForm({
        company: [],
        time: 604800,
        time_period: "",
        unit: 86400,
        // periodic: "daily",
        // report_day: 1,
        // report_hour: 0,
        // account_device: [],
        account_parameter: [],
        device_device: [],
        device_parameter: [],
      })
    );
  }, [stateCid]);

  return (
    <div ref={componentRef}>
      {/* <BackTop visibilityHeight={100} className={styles.unPrint} /> */}
      <Card
        extra={
          Boolean(filterForm?.device_parameter?.length || account_parameter.length) && (
            <Space size={1} className={styles.unPrint}>
              <ExportCSV />
              <PreferenceDrawer />
              {!isDarkMode && (
                <Button disabled={isFetchingAPI} onClick={handlePrint}>
                  Print
                </Button>
              )}
            </Space>
          )
        }
        headStyle={{ marginBottom: "-16px" }}
        bodyStyle={{ padding: 0 }}
        bordered={false}
      >
        <MultiDrawer />
        <DeviceChartsDrawer />
        {/* Print Only Head Page */}
        <CoverPage />
        {/* Account Level ChartList */}
        {Boolean(filterForm.account_parameter?.length) && (
          <AccountCharts parameter={filterForm.account_parameter || []} />
        )}

        {/* Device Level ChartList */}
        {Boolean(filterForm.device_parameter?.length) && (
          <DeviceCharts device={filterForm?.device_device || []} parameter={filterForm.device_parameter || []} />
        )}

        <EndPage />
      </Card>
    </div>
  );
};

export default ChartsList;
